import { ScheduleRouteRepetionDescriptionConfig } from './types';
import { repetitionStrategies } from './stategies';
import { normalizeAndSortWeeklyDays, getWeeklyDayLabels } from './helpers';

export const buildScheduleRouteRepetionDescription = ({
  repetitionTypeId,
  repeatInterval,
  repetitionIntervalArray,
  dayFormat = 'short',
}: ScheduleRouteRepetionDescriptionConfig): string => {
  const strategy = repetitionStrategies[repetitionTypeId];

  if (!strategy) return 'Sin configuración';

  const normalizedDays = normalizeAndSortWeeklyDays(repetitionIntervalArray);
  const dayLabels = getWeeklyDayLabels({
    days: normalizedDays,
    format: dayFormat,
  });

  return strategy({ repeatInterval, dayLabels });
};
